import RebateServices from "./RebateServices";
import RebateServicesMock from "./RebateServicesMock";

const isMockingService = process.env.VUE_APP_MOCKING_SERVICES === 'true' || process.env.VUE_APP_MOCKING_SERVICES === true;
export default isMockingService ? RebateServicesMock : RebateServices;
